import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { getMasterFileErrorLogs } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useMasterErrorLogs = () => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['MasterErrorLogs'],
    queryFn: () => getMasterFileErrorLogs(),
    select: (res) => res?.data || {},
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch list'),
        status: 'error',
      });
    },
  });

  return {
    masterErrorLogs: data?.result || [],
    isLoading: isLoading || isFetching,
  };
};
